import type { ShipmentDetail } from '#/shared/api/generated/shipment/models'
import { formatPhone, usPhoneToE164 } from '#/shared/lib/format'

export interface NumberOption {
  /** E.164 (or raw) value used to query the conversation. */
  value: string
  /** Pretty number shown on the chip. */
  display: string
}

/** Customer's distinct numbers — primary, alternate, then company. */
export function customerNumbers(
  customer: ShipmentDetail['customer'],
): NumberOption[] {
  const raws = [
    customer?.phone,
    customer?.secondary_phone,
    customer?.company_phone,
  ]
  const seen = new Set<string>()
  const options: NumberOption[] = []
  for (const raw of raws) {
    if (!raw) continue
    const value = usPhoneToE164(raw) ?? raw
    const display = formatPhone(raw)
    if (display === '' || seen.has(value)) continue
    seen.add(value)
    options.push({ value, display })
  }
  return options
}
